import {
  type PaginationQuery,
  ScriptsResponseSchema,
} from "@fapinstructor/common";
import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";
import { SCRIPT_QUERY_KEY } from "../script/get-script";

type GetScriptsParams = PaginationQuery & {
  userId?: string | null;
  bookmarked?: boolean | null;
  search?: string | null;
};

export const SCRIPTS_QUERY_KEY = [SCRIPT_QUERY_KEY, "list"];

async function getScripts(params?: GetScriptsParams) {
  const scripts = await fapinstructorApi
    .get("/scripts", {
      params,
    })
    .json(ScriptsResponseSchema);
  return scripts;
}

export function useScripts(params?: GetScriptsParams) {
  const query = useInfiniteQuery(scriptsQueryOptions(params));
  return query;
}

export const scriptsQueryOptions = (params?: GetScriptsParams) =>
  infiniteQueryOptions({
    queryKey: [...SCRIPTS_QUERY_KEY, { filters: params }],
    queryFn: ({ pageParam }) => getScripts({ ...params, cursor: pageParam }),
    initialPageParam: "",
    getNextPageParam: (lastPage) => lastPage.pagination.next,
    throwOnError: true,
  });
